function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_33",
  "data-name": "Group 33",
  transform: "translate(-377.35 -427.21)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_25",
  "data-name": "Path 25",
  d: "M762.423,551.187v12c0,.452,0,.452-.454.452h-97.62c-.519,0-.519,0-.519-.527V551.285c0-.585,0-.585.579-.585h97.515C762.423,550.7,762.423,550.7,762.423,551.187Z",
  transform: "translate(-214.609 -92.51)",
  fill: "#2bb673"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_45",
  "data-name": "Rectangle 45",
  width: 45.591,
  height: 12.983,
  transform: "translate(396.976 458.155)",
  fill: "#2b3990"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_31",
  "data-name": "Group 31",
  transform: "translate(377.388 427.21)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_26",
  "data-name": "Path 26",
  d: "M801.872,433.153a12.275,12.275,0,0,1,4.222-.687,40.024,40.024,0,0,1,6.912.279,8.377,8.377,0,0,1,3.038,1.039,3.1,3.1,0,0,1,1.493,1.937c.063.253.088.514.133.788h6.5c-.1-.768-.138-1.513-.289-2.233a7.525,7.525,0,0,0-4.511-5.459,19.538,19.538,0,0,0-7.765-1.57c-2.057-.068-4.117-.015-6.174-.025a21.47,21.47,0,0,0-6.425.84,10.645,10.645,0,0,0-7.639,7.519,18.27,18.27,0,0,0-.276,8.853,10.632,10.632,0,0,0,7,8.311,19.118,19.118,0,0,0,6.746,1.152,73.33,73.33,0,0,0,8.753-.183,16.55,16.55,0,0,0,5.293-1.387,8.5,8.5,0,0,0,5.173-7.747c.085-1.706.045-3.422.058-5.133a.953.953,0,0,0-.03-.191H804.9v4.526h12.76c-.048.361-.07.645-.125.923a4.1,4.1,0,0,1-2.476,2.935,10.729,10.729,0,0,1-4.162.953c-1.606.08-3.219.085-4.827.07a13,13,0,0,1-3.733-.542,6.734,6.734,0,0,1-4.754-4.393,10.354,10.354,0,0,1-.374-4.659A6.732,6.732,0,0,1,801.872,433.153Z",
  transform: "translate(-687.02 -427.21)",
  fill: "#2b3990"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_27",
  "data-name": "Path 27",
  d: "M686.818,446.321a17.639,17.639,0,0,0,1.929-1.756,9.035,9.035,0,0,0,1.841-7.318,8.058,8.058,0,0,0-5.426-6.708,12.47,12.47,0,0,0-4.553-.768q-8.264-.008-16.528,0h-.411v25.366H669.8v-7.14c.115-.01.183-.023.248-.023q4.952,0,9.9-.005a.412.412,0,0,1,.409.279c1.177,2.205,2.366,4.405,3.537,6.611a.487.487,0,0,0,.5.306c2.092-.013,4.185-.008,6.279-.008.11,0,.221-.01.391-.018-1.54-2.888-3.061-5.732-4.586-8.592A3.43,3.43,0,0,0,686.818,446.321Zm-3.036-5.391a2.978,2.978,0,0,1-2.77,1.789c-3.668.038-7.336.015-11,.015-.058,0-.113-.013-.186-.02v-7.7h.364c3.495,0,6.992-.005,10.487,0a3.32,3.32,0,0,1,2.817,1.252,3.435,3.435,0,0,1,.677,1.741A5.209,5.209,0,0,1,683.783,440.93Z",
  transform: "translate(-591.877 -429.126)",
  fill: "#2b3990"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_28",
  "data-name": "Path 28",
  d: "M470.989,445.853l-.083.015c-.07-.115-.143-.228-.213-.344q-4.595-7.741-9.179-15.481a.507.507,0,0,0-.507-.294c-1.691.013-3.382.005-5.073.005h-.354v25.361h5.589v-16.43c.128.2.2.316.268.434q4.591,7.857,9.177,15.72a.533.533,0,0,0,.537.308c1.691-.012,3.382-.007,5.07-.007.123,0,.243-.01.361-.018V429.78h-5.595Z",
  transform: "translate(-435.992 -429.112)",
  fill: "#2b3990"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_29",
  "data-name": "Path 29",
  d: "M574.3,444.686H584.32v-5.073H574.3v-4.727H585.76V429.84H568.51v25.343h17.253v-5.035H574.3Z",
  transform: "translate(-520.591 -429.18)",
  fill: "#2b3990"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_30",
  "data-name": "Path 30",
  d: "M962.926,429.727c-2.265,0-4.531-.005-6.8.008a.619.619,0,0,0-.4.233q-3.917,5.246-7.82,10.5c-.133.178-.271.351-.419.547-.073-.093-.115-.146-.156-.2q-3.947-5.415-7.89-10.835a.513.513,0,0,0-.464-.273c-2.323.013-4.646.013-6.969.018-.083,0-.166.018-.276.028.073.1.115.168.166.231q6.134,8,12.27,16a1.2,1.2,0,0,1,.263.785c-.012,2.642-.007,5.286-.007,7.93v.4h6.146v-.439c0-2.689,0-5.379.007-8.068a.881.881,0,0,1,.158-.5q5.577-7.361,11.174-14.709c.406-.534.808-1.071,1.244-1.646C963.034,429.732,962.981,429.727,962.926,429.727Z",
  transform: "translate(-792.688 -429.083)",
  fill: "#2b3990"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31",
  "data-name": "Path 31",
  d: "M377.5,455.191h12.965v-5.033H383.3v-5.472h5.707v-5.058H383.29v-4.754h7.175V429.84H377.5Z",
  transform: "translate(-377.5 -429.18)",
  fill: "#2b3990"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_46",
  "data-name": "Rectangle 46",
  width: 12.965,
  height: 12.988,
  transform: "translate(377.35 458.15)",
  fill: "#2b3990"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_32",
  "data-name": "Group 32",
  transform: "translate(450.429 478.528)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_32",
  "data-name": "Path 32",
  d: "M796.2,636.279c.048-.033.083-.06.12-.083a2.171,2.171,0,0,0,1.149-2.273,2.084,2.084,0,0,0-1.9-1.759,19.529,19.529,0,0,0-2.1-.065c-.512-.008-.677.166-.677.677q0,2.152,0,4.307c0,.805,0,1.608,0,2.413a.474.474,0,0,0,.529.532c.379,0,.539-.183.542-.67.008-1.162,0-2.321,0-3.482,0-.815-.005-1.631.01-2.446,0-.1.115-.276.181-.279a9.773,9.773,0,0,1,1.41.053,1.072,1.072,0,0,1,.908,1.023,1.141,1.141,0,0,1-.785,1.2,2.919,2.919,0,0,1-.68.093c-.3.015-.514.115-.542.449s.135.512.482.6a.955.955,0,0,1,.452.211,2.91,2.91,0,0,1,.554.735c.321.682.6,1.385.883,2.082a.581.581,0,0,0,.758.411.544.544,0,0,0,.271-.748A7.489,7.489,0,0,0,796.2,636.279Z",
  transform: "translate(-761.643 -632.016)",
  fill: "#2b3990"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_33",
  "data-name": "Path 33",
  d: "M1039.838,638.982c-.793-.008-1.585,0-2.378,0h-.4c0-.775.013-1.51-.008-2.243-.007-.293.093-.369.374-.361.667.015,1.335,0,2,0a.478.478,0,0,0,.532-.469c.038-.364-.188-.574-.64-.579-.733-.008-1.468,0-2.258,0,0-.65.013-1.257-.008-1.864-.01-.288.1-.344.361-.341.735.015,1.473.01,2.208,0,.359-.005.519-.166.524-.5a.471.471,0,0,0-.524-.537q-1.554-.015-3.106,0a.468.468,0,0,0-.529.532q0,3.432,0,6.859c0,.384.158.537.549.537q1.656.008,3.311,0a.489.489,0,0,0,.552-.514A.5.5,0,0,0,1039.838,638.982Z",
  transform: "translate(-943.827 -632.001)",
  fill: "#2b3990"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_34",
  "data-name": "Path 34",
  d: "M735.255,638.983c-.793-.005-1.585,0-2.381,0-.12,0-.243-.01-.4-.017,0-.753.015-1.475-.005-2.2-.01-.3.068-.4.381-.391.665.023,1.335.013,2,0,.371-.008.539-.191.532-.532s-.206-.512-.632-.514c-.745-.005-1.49,0-2.275,0,0-.652.01-1.269,0-1.887-.005-.238.07-.321.314-.316.748.013,1.5.008,2.243,0,.384,0,.544-.161.547-.507a.474.474,0,0,0-.537-.527c-1.024-.01-2.047-.008-3.071,0-.384,0-.552.171-.552.547q-.008,3.413,0,6.826c0,.411.151.557.565.557q1.641.008,3.279,0a.5.5,0,0,0,.575-.5A.515.515,0,0,0,735.255,638.983Z",
  transform: "translate(-715.667 -632.003)",
  fill: "#2b3990"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_35",
  "data-name": "Path 35",
  d: "M672.5,635.834c-.314-.208-.657-.371-.988-.552-.371-.206-.755-.389-1.111-.617a.873.873,0,0,1-.419-1.006,1.046,1.046,0,0,1,.815-.758,1.782,1.782,0,0,1,1.6.421.521.521,0,0,0,.763-.07.544.544,0,0,0-.123-.79,2.948,2.948,0,0,0-2.5-.585,2.063,2.063,0,0,0-1.658,1.523,1.889,1.889,0,0,0,.868,2.142c.366.253.78.437,1.164.665a10.065,10.065,0,0,1,1.124.72.918.918,0,0,1,.281.592,1.214,1.214,0,0,1-1.219,1.322,2.326,2.326,0,0,1-1.6-.6.551.551,0,0,0-.768.1.587.587,0,0,0,.12.748,3.207,3.207,0,0,0,2.045.815,7.252,7.252,0,0,0,.848-.118,2.117,2.117,0,0,0,1.673-1.683A2.034,2.034,0,0,0,672.5,635.834Z",
  transform: "translate(-668.645 -631.79)",
  fill: "#2b3990"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_36",
  "data-name": "Path 36",
  d: "M858.445,632.086c-.309-.043-.512.108-.637.492-.391,1.207-.768,2.418-1.172,3.623-.276.828-.59,1.646-.888,2.466l-.088,0c-.065-.153-.141-.306-.193-.464q-.933-2.815-1.861-5.632a.59.59,0,0,0-.748-.462c-.321.1-.429.346-.306.75.208.69.406,1.382.647,2.06.542,1.518,1.106,3.028,1.666,4.538a.878.878,0,0,0,1.646-.015c.3-.793.632-1.57.913-2.368.5-1.412.966-2.835,1.438-4.255A.5.5,0,0,0,858.445,632.086Z",
  transform: "translate(-806.378 -632)",
  fill: "#2b3990"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_37",
  "data-name": "Path 37",
  d: "M972.164,632.892a4.045,4.045,0,0,1,1.066.442.522.522,0,0,0,.707-.12.494.494,0,0,0-.048-.712,1.12,1.12,0,0,0-.329-.243,3.958,3.958,0,0,0-3.324-.221,4.005,4.005,0,0,0-2.328,3.971,6.539,6.539,0,0,0,.113.9,3.508,3.508,0,0,0,2.777,2.9,4.207,4.207,0,0,0,2.822-.507.529.529,0,0,0,.314-.725.537.537,0,0,0-.785-.241,8.866,8.866,0,0,1-.921.374,2.293,2.293,0,0,1-2.885-1.345,3.707,3.707,0,0,1-.161-2.586A2.455,2.455,0,0,1,972.164,632.892Z",
  transform: "translate(-892.832 -631.767)",
  fill: "#2b3990"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_38",
  "data-name": "Path 38",
  d: "M920.927,632.179a.531.531,0,0,0-.828.479c.028,1.448.01,2.893.01,4.34,0,.825-.005,1.653,0,2.479a.473.473,0,0,0,.554.537c.344-.01.5-.183.5-.595.005-1.127,0-2.25,0-3.377s.01-2.228-.01-3.339A.756.756,0,0,0,920.927,632.179Z",
  transform: "translate(-857.016 -632.001)",
  fill: "#2b3990"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170.501,
    height: 59.437,
    viewBox: "0 0 170.501 59.437",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.fd9a7b0c.svg";
export { ForwardRef as ReactComponent };